import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Event from "@material-ui/icons/Event";
import ScheduleIcon from "@material-ui/icons/Schedule";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import capExResWelcomeStyle from "assets/jss/material-kit-pro-react/views/capabilityExplorerResultsPageSections/capExResWelcomeStyle.jsx";

class CapExResWelcomeSection extends React.Component {

  render() {
    const firstname = this.props.actor.name; // "{Firstname}";
    const completionDate = new Date(this.props.timestamp);
    const startedDate = new Date(this.props.started);
    const diffTime = Math.abs(completionDate.getTime() - startedDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
    const diffMinutes = Math.ceil(diffTime / (1000 * 60));

    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10}>
            <h2 className={classes.title}>Hi {firstname}</h2>
            <h5 className={classes.description}>
              The results on this page are your individual results from the
              Capabilty Explorer.
            </h5>
            <List className={classes.list} dense="true">
              <ListItem>
                <Avatar>
                  <Event />
                </Avatar>
                <ListItemText
                  primary="Completed"
                  secondary={
                    completionDate.toLocaleDateString() +
                    " " +
                    completionDate.toLocaleTimeString()
                  }
                />
              </ListItem>
              <ListItem>
                <Avatar>
                  <ScheduleIcon />
                </Avatar>
                <ListItemText
                  primary="Total time"
                  secondary={diffMinutes + " minutes"}
                />
              </ListItem>
            </List>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(capExResWelcomeStyle)(CapExResWelcomeSection);
